import { AppThunk } from "../../store";
import { reviewActions } from "./reviewSlice";
import { apiFetch } from "../../../utils/api";
import { toPage, withPaging } from "../../../utils/pagination";
import { ReviewRequest, ReviewResponse } from "../../../types/reviewTypes";

export const submitReview =
  (payload: ReviewRequest): AppThunk<Promise<ReviewResponse | null>> =>
  async (dispatch) => {
    try {
      dispatch(reviewActions.startLoading());
      const data: ReviewResponse = await apiFetch(
        "/api/reviews",
        { method: "POST", body: JSON.stringify(payload) },
        true
      );
      return data;
    } catch (e: any) {
      dispatch(reviewActions.setError(e.message));
      return null;
    } finally {
      dispatch(reviewActions.endLoading());
    }
  };

export const fetchReviewsForProvider =
  (providerId: number, page: number = 0): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(reviewActions.startLoading());
      const data = await apiFetch(withPaging(`/api/reviews/provider/${providerId}`, page), {}, false);
      dispatch(reviewActions.setReviewsPage({ providerId, page: toPage(data) }));
    } catch (e: any) {
      dispatch(reviewActions.setError(e.message));
    } finally {
      dispatch(reviewActions.endLoading());
    }
  };
